import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/site/:siteId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    siteId: string;
    parkingId: string;
}
const mutationFn = ({ siteId, parkingId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { siteId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteSite };
